export const escapeQuotesInString = (str = '') => str.replace(/'/g, "\\'").replace(/"/g, '\\"')

export function snakeCaseToCamelCase(word = '') {
  return (word || '').replace(/_(.)/g, (match, firstAfterHypen) => firstAfterHypen.toUpperCase())
}
